'use client';

import { useState } from 'react';
import QuizInterface from './QuizInterface';
import QuizResults from './QuizResults';

export default function StartHereInteractive() {
  const [showResults, setShowResults] = useState(false);
  const [track, setTrack] = useState<'collector' | 'debtor' | null>(null);

  const handleQuizComplete = (selectedTrack: 'collector' | 'debtor') => {
    setTrack(selectedTrack);
    setShowResults(true);
  };

  return (
    <div data-component-id="src/app/start-here/components/StartHereInteractive.tsx:17:4" data-component-path="src/app/start-here/components/StartHereInteractive.tsx" data-component-line="17" data-component-end-line="23" data-component-file="StartHereInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22py-24%20md%3Apy-32%20px-6%22%7D" className="py-24 md:py-32 px-6">
      {!showResults ? (
        <QuizInterface data-component-id="src/app/start-here/components/StartHereInteractive.tsx:19:8" data-component-path="src/app/start-here/components/StartHereInteractive.tsx" data-component-line="19" data-component-end-line="19" data-component-file="StartHereInteractive.tsx" data-component-name="QuizInterface" data-component-content="%7B%22elementName%22%3A%22QuizInterface%22%7D" onComplete={handleQuizComplete} />
      ) : (
        <QuizResults data-component-id="src/app/start-here/components/StartHereInteractive.tsx:21:8" data-component-path="src/app/start-here/components/StartHereInteractive.tsx" data-component-line="21" data-component-end-line="21" data-component-file="StartHereInteractive.tsx" data-component-name="QuizResults" data-component-content="%7B%22elementName%22%3A%22QuizResults%22%7D" track={track || 'collector'} />
      )}
    </div>
  );
}